import { container, I18N_TOKEN } from '@/container';
import {
  type ConversationGroupMessageType,
  ConversationMessageContentType,
  type ConversationMessageTypeUnion,
} from '@/models/conversations/conversation';

export function transformMessageTextByType(
  message: Partial<
    Pick<ConversationMessageTypeUnion, 'MsgType' | 'Message' | 'UserNickName'> &
      Pick<ConversationGroupMessageType, 'UserRole'>
  >,
  remarkName?: string,
): string {
  const { t } = container.resolve(I18N_TOKEN);
  const { MsgType, Message = '', UserNickName } = message;
  const isGroup = 'GroupID' in message;
  const isSystemAdmin = Boolean(isGroup && message.UserRole && message.UserRole > 10);
  const displayName = isSystemAdmin ? t('common.system-admin') : remarkName || UserNickName;
  let msgText = isGroup ? `${displayName}：` : '';

  switch (MsgType) {
    case ConversationMessageContentType.JoinGroup:
      return t('message.join', { user: displayName });
    case ConversationMessageContentType.LeaveGroup: {
      const isSelfLeave = UserNickName && Message.includes(UserNickName);
      return !isSelfLeave
        ? t('message.kick', {
            user: displayName,
            admin: Message,
          })
        : t('message.leave', { user: displayName });
    }
    case ConversationMessageContentType.Video:
      msgText += `[${t('message.video')}]`;
      break;
    case ConversationMessageContentType.Image:
      msgText += `[${t('message.picture')}]`;
      break;
    case ConversationMessageContentType.File:
      msgText += `[${t('message.document')}]`;
      break;
    case ConversationMessageContentType.Audio:
      msgText += `[${t('message.audio')}]`;
      break;
    case ConversationMessageContentType.Call:
      msgText += `[${t('message.call')}]`;
      break;
    case ConversationMessageContentType.Contact:
      msgText += `[${t('message.contact')}]`;
      break;
    case ConversationMessageContentType.Emoticon:
      msgText += `[${t('message.emoticon')}]`;
      break;
    case ConversationMessageContentType.Invite:
      msgText += `[${t('message.invite')}]`;
      break;
    case ConversationMessageContentType.Notice:
      msgText += `[${isGroup ? t('message.announcement') : t('message.notice')}]`;
      break;
    case ConversationMessageContentType.AllBan:
      // NOTE: do not like this either, but there's no other way @nelson.liu
      msgText += `[${Message.includes('解除') ? t('message.unmute-all') : t('message.mute-all')}]`;
      break;
    default:
      msgText += Message;
      break;
  }

  return msgText;
}
